<template>
    <div class="company-logo-wrapper" @click="$refs.fileInput.click()">
        <img :src="src" class="logo" alt="Logo" />
        <input
            ref="fileInput"
            accept="image/x-png,image/gif,image/jpeg"
            class="file-input"
            type="file"
            @change="upload"
        />
        <div v-if="isSaving" class="uploading">
            <i class="uk-icon-spinner uk-icon-spin" />
        </div>
        <div class="click-to-upload">
            <span>Update</span>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'
import { saveLogo } from '@/api/survey'
import { getCDNUrl } from '@/utils/cdn'

@Component({})
export default class CompanyLogo extends Vue {
    @Prop({ type: String })
    url

    isSaving = false
    uploadedUrl = null

    get src() {
        return getCDNUrl(this.uploadedUrl ?? this.url)
    }

    async upload(event: Event) {
        if (this.isSaving) {
            return
        }

        const files = (event.target as HTMLInputElement).files
        if (files && files[0]) {
            this.isSaving = true
            const { data } = await saveLogo(files[0], 'default', 'company')
            this.uploadedUrl = data.logo ?? this.url
            this.isSaving = false
        }
    }
}
</script>

<style scoped lang="less">
.company-logo-wrapper {
    position: relative;

    input {
        display: none;
    }

    .logo {
        cursor: pointer;
    }

    .uploading {
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        background: white;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .click-to-upload {
        display: none;
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        background: black;
        color: white;
        width: 100%;
        height: 100%;
        z-index: 1;
        cursor: pointer;
        align-items: center;
        justify-content: center;
    }

    &:hover .click-to-upload {
        display: flex;
    }
}
</style>
